export const GET_MEMO = "/Memo/GetMemoByObjectGuid"
